module.exports = __webpack_public_path__ + "static/img/3.de325c6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/2/eng/3.png
// module id = WX0Y
// module chunks = 0